import GenericCard from '../../../../components/GenericCards';
import { Col, Row } from 'react-bootstrap';
import IconButton from '../../../../components/IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { formatPrice } from '../../../../utils/utils';
import Blockquote from '../../../../components/Blockquote';
import Button from '../../../../components/Button';
import React, { useState } from 'react';

const generateChartOptions = () => {
  return {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: ['1', '2', '3', '4'],
    },
    yaxis: {
      show: false,
      lines: {
        show: true,
      },
    },
  };
};

const generateChartSeries = (data: any[]) => {
  return [
    ...data.map((d) => {
      return {
        name: d.contribution,
        color: d.color,
        data: [d.contributionAmount],
      };
    }),
  ];
};

export const CompanyContributions = () => {
  const companyContributions = [
    {
      color: '#074CBC',
      contribution: 'YTD Company Contributions',
      contributionAmount: 800,
    },
    {
      color: '#F48462',
      contribution: 'Estimated Year End Total',
      contributionAmount: 1000,
    },
    {
      color: '#07B4A0',
      contribution: 'Full Match',
      contributionAmount: 1600,
    },
  ];

  const [showCompanyContributionsChart, setShowCompanyContributionsChart] =
    useState<boolean>(false);
  return (
    <GenericCard variant={'white'}>
      <Row className="align-items-center">
        <Col className={'col-10'}>
          <h5>Company Match</h5>
        </Col>
        <Col className={'col-2'}>
          <IconButton
            variant="icon-emphasized"
            icon={
              !showCompanyContributionsChart
                ? light('pie-chart')
                : light('circle-minus')
            }
            onClick={() =>
              setShowCompanyContributionsChart((prevState) => !prevState)
            }
          />
        </Col>
      </Row>

      <Row
        className={`${
          !showCompanyContributionsChart ? 'd-none' : 'd-block'
        } mt-10 `}
      >
        <Col className={`col-12 `}>
          <Chart
            options={generateChartOptions() as ApexOptions}
            series={generateChartSeries(companyContributions)}
            type={'bar'}
          />
        </Col>
      </Row>

      <Row>
        <Col className={'col-12 mt-8'}>
          <Row>
            <Col>
              <Row className="text-fs-6 fw-light pt-3 lh-xs border-bottom">
                <Col className="text-end fw-normal pe-0 col-1"></Col>
              </Row>

              {companyContributions.map((contributionPoint, index) => {
                return (
                  <Row
                    className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom "
                    key={index}
                  >
                    <Col className="pt-1 ps-0 col-1 pe-0">
                      <div
                        className="custom-legend-marker"
                        style={{
                          backgroundColor: `${contributionPoint.color}`,
                        }}
                      ></div>
                    </Col>
                    <Col className="col-6 ps-0 ">
                      {contributionPoint.contribution}
                    </Col>

                    <Col className="col-5 text-end pe-0">
                      {formatPrice(
                        Number(contributionPoint.contributionAmount),
                        'en-US',
                        {
                          currency: 'USD',
                          style: 'currency',
                          minimumFractionDigits: 0,
                        }
                      )}
                    </Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
        </Col>

        <Col className={'col-12 mt-10'}>
          <Blockquote>
            <span className="text-dark-gray fw-bold">Did you know?</span>
            <ul className="text-dark-gray">
              <li>
                You're missing the company match and leaving free money on the
                table.
              </li>
              <li>
                Increasing your contribution to 6% will earn you an additional
                $600.
              </li>
            </ul>
          </Blockquote>
        </Col>
        <Col className={'col-12 mt-5 text-end d-none d-lg-block'}>
          <Button color={'blue'}>Change Contributions</Button>
        </Col>
        <Col className={'col-12 mt-5 text-end d-lg-none'}>
          <Button color={'blue'} variant={'primary-outline'}>
            More Details
          </Button>
        </Col>
      </Row>
    </GenericCard>
  );
};
